import React from 'react'
import "./Holiday.min.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { Link, Outlet } from 'react-router-dom';
const L4 : React.FC = () => {
  const test = () => {
    console.log("b")
  }
  return (
    <div className='holiday'>
      <div className='title'>
        <Link to='..'> <FontAwesomeIcon id='faArrowLeft' icon={faArrowLeft} /></Link>
        <span id='title'>Holiday</span>
      </div>
      <div className='holidayList2L4'>
        <Link to='/Holiday'>Urlop</Link>
        <Link to='/Holiday/L4'>L4</Link>
      </div>

      <Outlet />
      <footer>
        <button type='button' onClick={() => test()} id='circle'><p>+</p></button>
      </footer>
    </div>
  )
}

export default L4